import { validateForm } from '../main';

$(function () {
  $('button.js-summary').click(function (e) {
    e.preventDefault();
    if (validateForm($(this.form))) {
      formSummary(this.form);
    }
  });

  function formSummary(form) {
    var $inputs = $(':input', form);
    var html = '';
    var id = '';
    var summaryButton = $('button.js-summary', form);
    var title = summaryButton.data('summaryTitle');
    var editBtn = summaryButton.data('btnEdit');
    var summaryForward = summaryButton.data('summaryForward');
    var sendBtn = summaryButton.data('btnSend');

    html += '<div class="contactFormSummaryContainer"><h3>' + title + '</h3>';
    var formType = $(form).data('formType');
    $inputs.each(function () {
      switch (this.type) {
        case 'text':
          if ($(this).val()) {
            html +=
              '<div class="formRow"><span>' +
              $(this).attr('placeholder') +
              ':</span> ' +
              $(this).val() +
              ' </div>';
          }
          break;
        case 'radio':
          if ($(this).prop('checked')) {
            html +=
              '<div class="formRow"><span>' +
              $(this).parentsUntil('.formContainer').find('.formLabel').text() +
              ':</span> ' +
              $(this).parent('label').text() +
              ' </div>';
          }
          break;
        case 'checkbox':
          if ($(this).prop('checked')) {
            html +=
              '<div class="formRow"><span>' + $(this).parent('label').text() + ':</span>Ja</div>';
          }
          break;
        case 'select-one':
          if ($(this).val()) {
            var selectName = $(this)
              .parentsUntil('.formContainer')
              .filter('.formRow')
              .prev('.formLabel')
              .text();
            if (!selectName) {
              selectName = $(this).attr('name');
            }

            html +=
              '<div class="formRow"><span>' + selectName + ':</span> ' + $(this).val() + ' </div>';
          }
          break;
        case 'textarea':
          if ($(this).val()) {
            html +=
              '<div class="formRow"><span>' +
              $(this).parent('.form-label-group').text() +
              ':</span>' +
              $(this).val() +
              '</div>';
          }
          break;
        case 'hidden':
          if ($(this).val() && this.name === 'id') {
            id = $(this).val();
          }
          break;
      }
    });
    html +=
      '<div class="formRow"><button class="btn-primary waves-effect waves-block waves-light js-editSummary" data-target="#' +
      id +
      '.' +
      formType +
      '">' +
      editBtn +
      '</button>';
    html +=
      '<button class="btn-primary waves-effect waves-block waves-light js-sendForm" type="submit" data-target="#' +
      id +
      '.' +
      formType +
      '">' +
      sendBtn +
      '</button></div></div>';
    $(form).find('.formContainer').hide();
    $(html).appendTo($(form));
    $('button.js-editSummary').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var target = $(this).data('target');
      if ($(target).length > 0) {
        $(target).find('.formContainer').show();
        $(target).find('.contactFormSummaryContainer').hide();
      }
    });
    $('button.js-sendForm').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var target = $(this).data('target');
      var $contactForm = $(this).closest('form');
      var data = $contactForm.serialize();
      $.ajax({
        url: $contactForm.attr('action'),
        type: 'POST',
        data: data,
        success: function () {
          if (summaryForward) {
            //Direkte Weiterleitung auf eigenständige Dankesseite
            location.href = summaryForward;
          } else {
            var selCTA = $(
              target.substring(0, target.lastIndexOf('.')) + '.js-contactModalSuccess'
            );
            var selComponent = $(
              target.substring(0, target.lastIndexOf('.')) + '.contactComponentSuccess'
            );
            // Find Thank you for CTA and show it
            if (selCTA.length > 0) {
              selCTA.addClass('show');
            }
            // Or find Thank you for Component and show it
            else if (selComponent.length > 0) {
              selComponent.toggleClass('hide');
              var selOrig = $(
                target.substring(0, target.lastIndexOf('.')) + '.js-contact-component'
              );
              selOrig.toggleClass('hide');
            }
            // Otherwise: Show/Hide for Contact-Button from Settingspage
            else {
              $('.js-standardContact.overlay').hide();
              $('.js-standardContactThanks').show();
            }
          }
        },
        error: function () {
          alert($('.js-standardContact.overlay').attr('data-errormessage'));
        },
      });
    });
  }
});
